import { useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import FooterLogo from "../components/FooterLogo";
import FormObserver from "../components/FormElements/FormObserver";
import { Form, Formik } from "formik";
import { object, string } from "yup";
import { FormInput } from "../components/FormElements";
import { Button } from "../components/Elements";
import ReCAPTCHA from "react-google-recaptcha";
import commonNetwork from "../../common/api/commonNetwork";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootStateType } from "../../store/RootState";
import { Helmet } from "react-helmet"; 
import { getNavigationUrl } from "../../common/helpers/navigationHelpers";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../store/recoil/tenant/atoms";

type FormProps = {
    userName: string,
}

const ForgotPassword = () => {

     const {firmInformations} = useRecoilValue(tenantState);

    const isRequireFirmCode = firmInformations.firmCode=="ORTAKODEME";

    const [Loading, setLoading] = useState(false);
    const recaptchaRef = useRef<any>();
    const [capthaLoad, setCapthaLoad] = useState(false);
  

    setTimeout(() => {
        setCapthaLoad(true);
    }, 500);

 
    const onSubmit = async (values: FormProps) => {
        setLoading(true);
        let token = "";
        try {
            token = await recaptchaRef.current.executeAsync();
        } catch (error) {

        }
        const params = {
            firmcode: firmInformations.firmCode,
            username: values.userName,
            token: token
        }

        const result = await commonNetwork.post("/token/forgot-password", params);
        const { data, isSuccess, errorMessage } = result;

        setLoading(false);
        if (isSuccess) { 
            toast.success(data);
        } else {
            toast.error(result.errorMessage);
        }
    }

    const initialValues = {
        userName: "",
    }

    const filtersSchema = object({
        userName: string().required("Lütfen Kullanıcı adını giriniz."),
    });




    return (
        <div className="flex flex-col md:flex-row h-screen items-center">

            <Helmet title={`Şifremi Unuttum`}
            >

            </Helmet>
            <div className="lg:block w-full md:w-1/2 xl:w-2/3 h-screen">
                <img src="/images/logopng.svg" className="w-full h-full object-cover" alt="Sample image" />
            </div>
            <div className="w-full md:w-1/3 right-side mb-4">


                <div className="max-[33%]">
                </div>
                <div className="px-6 lg:px-12 xl:px-10 text-center md:text-right justify-center md:justify-end">
                    <div className="text-center mb-8">
                        <img className="mx-auto w-48" src={`https://tahsilat.elogo.com.tr/etahsilatapitest/Uploads/firm_logos/${firmInformations.logoPath}`} alt="logo" />

                    </div>

                    <div className="flex flex-row items-center justify-center lg:justify-center m-b-10">
                        <h1 className="text-2xl font-semibold  mb-0 text-center">Şifremi Unuttum</h1>
                    </div>


                    <div className="flex flex-row items-center justify-center lg:justify-center mb-8 ">
                    </div>
                    <div className="flex items-center my-4 before:flex-1 before:border-t before:border-gray-300 before:mt-0.5 after:flex-1 after:border-t after:border-gray-300 after:mt-0.5">
                        <p className="text-center font-semibold mx-4 mb-0">Şifreyi Yenile</p>
                    </div>
                    <div className="mb-8">

                        <Formik
                            validationSchema={filtersSchema}
                            enableReinitialize
                            onSubmit={onSubmit}
                            initialValues={initialValues}
                        >
                            {formProps => (
                                <Form>
                                    <FormObserver watch={() => {

                                    }} />
                                    <div className="flex flex-col sm:text-left lg:text-center justify-start mt-3">
                                        <input type="hidden" name="CaptchaToken" id="CaptchaToken" value="" />

                                        {isRequireFirmCode ? (
                                            <div className=" mt-3">
                                                <div>
                                                    <div className="w-full relative">
                                                        <FormInput
                                                            label="Firma Kodu*"
                                                            name="firmCode"
                                                            type="text"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        ) : (
                                            <input type="hidden" name="firmCode" id="firmCode" value={firmInformations.firmCode} />
                                        )}
                                        <div className=" mt-3">
                                            <div>
                                                <div className="w-full relative">
                                                    <FormInput
                                                        label="Kullanıcı Adı*"
                                                        name="userName"
                                                        type="text"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className=" mt-4 flex justify-end">
                                            <NavLink className="flex flex-row  not-italic  text-sm leading-5 font-semibold font-nunito text-primary"
                                                to={getNavigationUrl("/login/")}  >
                                                <a className="not-italic  text-sm leading-5 font-semibold font-nunito text-primary"
                                                    target={"_blank"} >
                                                    Giriş Yap
                                                </a>
                                            </NavLink>
                                        </div>
                                    </div>

                                    <div className="text-center lg:text-center mb-4">
                                        <Button
                                            type="submit"
                                            color="primary"
                                            hover="primary"
                                            className={" w-full h-12 mt-6 px-7 py-3"}
                                            size="xl"
                                            disabled={Loading}
                                            loading={Loading}
                                        >
                                            ŞİFREMİ SIFIRLA
                                        </Button>

                                    </div>

                                </Form>
                            )}
                        </Formik>

                    </div>
                </div>
                {capthaLoad && (
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        size="invisible"
                        sitekey="6LewgCwmAAAAAD6pjQQbOP9Dxq7AC025wgOuNZDb"
                    />
                )}


                <div
                    className="flex items-endflex items-end justify-center "

                >
                    <FooterLogo />
                </div>
            </div>

        </div>
    );
}
export default ForgotPassword;